<template>
    <div class="bg-black text-gray-300">
        <section
            class="bg-[center_top_-20px] bg-no-repeat bg-logo-outline-fade bg-contain overflow-x-hidden at768:bg-[center_top_-40px] at1024:bg-auto at1024:pb-24"
        >
            <div
                class="px-4 py-24 relative text-center z-20 at768:py-32 at1024:px-8 at1024:py-56"
            >
                <h1
                    class="font-semibold leading-none max-w-[950px] mb-5 mx-auto text-5xl tracking-tight text-white at768:text-6xl at1024:text-[110px]"
                >
                    Nobody else’s inventory comes close
                </h1>
                <p
                    class="font-semibold leading-tight max-w-7xl mb-16 mx-auto text-gray-400 text-xl at768:text-3xl at1024:leading-tight at1024:text-[43px]"
                >
                    SECLOCK is the only partner you need for electrical and
                    mechanical door hardware, and our Parts Department is a
                    major reason why.
                </p>
                <a :href="route('register' )" class="btn-white-on-red"
                >Register to see why</a
                >
            </div>

            <!-- The --river-width value MUST be the exact width of one of the
            <ul> elements, based on the following formula:
            Box width = 296
            Box gap = 24
            Box quantity = 17   (as of this writing)
            - - - - - - - - - - - - - - - - - - - - - - -
            (296 + 24) x 17 = 5440
            -->
            <div
                class="image-river"
                style="
                    --river-width: 5440px;
                    --river-scroll-duration: 120s;
                    --box-height: 310px;
                    --box-width: 296px;
                    --box-bg: #25282a;
                    --box-radius: 8px;
                    --box-margin-inline: 12px;
                "
            >
                <div class="image-river--inner">
                    <ul>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SAR10056532D-1"
                                class=""
                                height="250"
                                width="250"
                                sizes="250px"
                                alt="Part SAR10056532D"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SCH10043001"
                                class=""
                                height="250"
                                width="249"
                                sizes="249px"
                                alt="Part SCH10043001"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/HAN100501630"
                                class=""
                                height="221"
                                width="221"
                                sizes="221px"
                                alt="Part HAN100501630"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LCN100411018AL"
                                class=""
                                height="261"
                                width="261"
                                sizes="261px"
                                alt="Part LCN100411018AL"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/BEA_10BGQD"
                                class=""
                                height="271"
                                width="271"
                                sizes="271px"
                                alt="Part BEA_10BGQD"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LOC10078818"
                                class=""
                                height="246"
                                width="246"
                                sizes="246px"
                                alt="Part LOC10078818"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/11-085_626"
                                class=""
                                height="279"
                                width="245"
                                sizes="245px"
                                alt="Part 11-085_626"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/CR_3070_178_626"
                                class=""
                                height="266"
                                width="266"
                                sizes="266px"
                                alt="Part CR_3070_178_626"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SAR100685068"
                                class=""
                                height="173"
                                width="238"
                                sizes="238px"
                                alt="Part SAR100685068"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/RY-18L-1"
                                class=""
                                height="303"
                                width="279"
                                sizes="279px"
                                alt="Part RY-18L-1"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LCN1004010T3034"
                                class=""
                                height="292"
                                width="257"
                                sizes="257px"
                                alt="Part LCN1004010T3034"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/VON100050492"
                                class=""
                                height="257"
                                width="257"
                                sizes="257px"
                                alt="Part VON100050492"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/BES1008KS2626"
                                class=""
                                height="241"
                                width="241"
                                sizes="241px"
                                alt="Part BES1008KS2626"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LCN100146062PAAL"
                                class=""
                                height="225"
                                width="226"
                                sizes="226px"
                                alt="Part LCN100146062PAAL"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SAR10025CPSEN"
                                class=""
                                height="251"
                                width="255"
                                sizes="255px"
                                alt="Part SAR10025CPSEN"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/RCI9512"
                                class=""
                                height="297"
                                width="296"
                                sizes="296px"
                                alt="Part RCI9512"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/IVES_FB458-12_US26_1"
                                class=""
                                height="310"
                                width="296"
                                sizes="296px"
                                alt="Part IVES_FB458-12_US26_1"
                            />
                        </li>
                    </ul>
                    <!-- Have to repeat the <ul> for infinite scroll: -->
                    <ul aria-hidden="true">
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SAR10056532D-1"
                                class=""
                                height="250"
                                width="250"
                                sizes="250px"
                                alt="Part SAR10056532D"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SCH10043001"
                                class=""
                                height="250"
                                width="249"
                                sizes="249px"
                                alt="Part SCH10043001"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/HAN100501630"
                                class=""
                                height="221"
                                width="221"
                                sizes="221px"
                                alt="Part HAN100501630"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LCN100411018AL"
                                class=""
                                height="261"
                                width="261"
                                sizes="261px"
                                alt="Part LCN100411018AL"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/BEA_10BGQD"
                                class=""
                                height="271"
                                width="271"
                                sizes="271px"
                                alt="Part BEA_10BGQD"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LOC10078818"
                                class=""
                                height="246"
                                width="246"
                                sizes="246px"
                                alt="Part LOC10078818"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/11-085_626"
                                class=""
                                height="279"
                                width="245"
                                sizes="245px"
                                alt="Part 11-085_626"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/CR_3070_178_626"
                                class=""
                                height="266"
                                width="266"
                                sizes="266px"
                                alt="Part CR_3070_178_626"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SAR100685068"
                                class=""
                                height="173"
                                width="238"
                                sizes="238px"
                                alt="Part SAR100685068"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/RY-18L-1"
                                class=""
                                height="303"
                                width="279"
                                sizes="279px"
                                alt="Part RY-18L-1"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LCN1004010T3034"
                                class=""
                                height="292"
                                width="257"
                                sizes="257px"
                                alt="Part LCN1004010T3034"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/VON100050492"
                                class=""
                                height="257"
                                width="257"
                                sizes="257px"
                                alt="Part VON100050492"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/BES1008KS2626"
                                class=""
                                height="241"
                                width="241"
                                sizes="241px"
                                alt="Part BES1008KS2626"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/LCN100146062PAAL"
                                class=""
                                height="225"
                                width="226"
                                sizes="226px"
                                alt="Part LCN100146062PAAL"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/SAR10025CPSEN"
                                class=""
                                height="251"
                                width="255"
                                sizes="255px"
                                alt="Part SAR10025CPSEN"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/RCI9512"
                                class=""
                                height="297"
                                width="296"
                                sizes="296px"
                                alt="Part RCI9512"
                            />
                        </li>
                        <li>
                            <img
                                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/IVES_FB458-12_US26_1"
                                class=""
                                height="310"
                                width="296"
                                sizes="296px"
                                alt="Part IVES_FB458-12_US26_1"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section id="parts-animation-context">
            <div id="parts-animation-inner" class="max-w-[1600px] mx-auto at1024:flex at1024:items-center">
                <div class="at1024:w-[55%]">
                    <lottie-player
                        id="parts-animation"
                        ref="partsAnimation"
                        src="https://marketing-assets.seclock.com/raw/upload/v1676396497/parts_land_v2.json"
                        class="at1350:-ml-[300px] at1350:w-[1350px]"
                    >
                    </lottie-player>
                </div>
                <div
                    class="relative px-4 at1024:pl-12 at1024:pr-8 at1024:w-[45%]"
                >
                    <h2
                        class="font-semibold leading-none max-w-[250px] mb-4 text-3xl text-white tracking-tight at768:max-w-sm at768:text-5xl at1200:max-w-md at1200:text-[70px]"
                    >
                        Big or small, we’ve got it all
                    </h2>
                    <p
                        class="leading-[1.15] at768:text-xl at1024:text-2xl at1200:leading-tight at1200:text-[35px]"
                    >
                        From arms and bodies that keep door closers working to
                        screw packs, latches, brackets and much more, SECLOCK’s
                        parts department stocks any part, accessory or component
                        you need to get the job done.
                    </p>
                </div>
            </div>
        </section>

        <section
            class="flex flex-col gap-12 max-w-8xl mx-auto pt-24 px-4 at768:pt-48 at1024:flex-row at1024:gap-8 at1024:pt-0 at1024:px-8 at1200:pt-24 at1350:items-center at1440:pt-48"
        >
            <div
                class="max-w-lg at1024:max-w-none at1024:pt-20 at1024:w-1/2 at1350:pt-0"
            >
                <h3
                    class="font-semibold leading-none max-w-[250px] mb-4 text-3xl text-white tracking-tight at768:max-w-md at768:text-5xl at1024:max-w-lg at1200:text-[70px]"
                >
                    Depth is good, breadth is better
                </h3>
                <p
                    class="leading-[1.15] at768:text-xl at1024:text-2xl at1200:leading-tight at1200:text-[35px]"
                >
                    Anybody can stock 1,000 units of the most popular product.
                    What sets us apart is just how wide our inventory is. And on
                    the rare occurrence we don’t have the piece you need, we’ll
                    work with you to find a solution using one we do.
                </p>
            </div>
            <div
                class="gap-[10px] grid grid-cols-2 leading-tight text-sm at768:grid-cols-3 at1024:grid-cols-2 at1024:w-1/2 at1350:grid-cols-3"
            >
                <dl class="bg-gray-800 px-4 py-6 rounded-md">
                    <dt
                        class="font-semibold leading-none mb-3 text-[27px] text-white"
                    >
                        <span
                            class="flex h-14 items-center justify-center mb-2 w-14"
                            ><BaseSvg name="cylindrical-lock"
                        /></span>
                        Lock Parts
                    </dt>
                    <dd>Cams</dd>
                    <dd>Tailpieces</dd>
                    <dd>Cylinders</dd>
                    <dd>Replacement levers</dd>
                    <dd>Compression rings</dd>
                    <dd>Escutcheons/Roses</dd>
                    <dd>Cylinders</dd>
                    <dd>Spindlest</dd>
                </dl>
                <dl class="bg-gray-800 px-4 py-6 rounded-md">
                    <dt
                        class="font-semibold leading-none mb-3 text-[27px] text-white"
                    >
                        <span
                            class="flex h-14 items-center justify-center mb-2 w-14"
                            ><BaseSvg name="door-closer"
                        /></span>
                        Door Closers
                    </dt>
                    <dd>Closer covers</dd>
                    <dd>Mounting plates</dd>
                    <dd>Brackets</dd>
                    <dd>Compressors</dd>
                    <dd>Replacement arms</dd>
                    <dd>Track rollers</dd>
                    <dd>Door coordinators</dd>
                </dl>
                <dl class="bg-gray-800 px-4 py-6 rounded-md">
                    <dt
                        class="font-semibold leading-none mb-3 text-[27px] text-white"
                    >
                        <span
                            class="flex h-14 items-center justify-center mb-2 w-14"
                            ><BaseSvg name="exit-device"
                        /></span>
                        Exit Devices
                    </dt>
                    <dd>Rod kits</dd>
                    <dd>Door cords</dd>
                    <dd>Replacement bars</dd>
                    <dd>Alarm kits</dd>
                    <dd>Case covers</dd>
                    <dd>Reinforcement brackets</dd>
                    <dd>End caps</dd>
                </dl>
                <dl class="bg-gray-800 px-4 py-6 rounded-md">
                    <dt
                        class="font-semibold leading-none mb-3 text-[27px] text-white"
                    >
                        <span
                            class="flex h-14 items-center justify-center mb-2 w-14"
                            ><BaseSvg name="electric-strike"
                        /></span>
                        Electric Strikes / Bolts / Magnets
                    </dt>
                    <dd>Mounting kits</dd>
                    <dd>Brackets</dd>
                    <dd>Filler Plates</dd>
                    <dd>Solenoids</dd>
                    <dd>Extension kits</dd>
                </dl>
                <dl class="bg-gray-800 px-4 py-6 rounded-md">
                    <dt
                        class="font-semibold leading-none mb-3 text-[27px] text-white"
                    >
                        <span
                            class="flex h-14 items-center justify-center mb-2 w-14"
                            ><BaseSvg name="misc-tools"
                        /></span>
                        Misc.
                    </dt>
                    <dd>Screw packs and covers</dd>
                    <dd>Latches, catches, and bolts</dd>
                    <dd>Retrofit kits</dd>
                    <dd>Faceplates</dd>
                    <dd>Relays</dd>
                    <dd>Rectifiers</dd>
                    <dd>Batteries</dd>
                    <dd>Monitors</dd>
                </dl>
            </div>
        </section>

        <section
            class="flex flex-col gap-12 max-w-8xl mx-auto py-24 px-4 at768:py-48 at1024:flex-row at1024:gap-8 at1024:items-center at1024:px-8"
        >
            <div
                class="order-2 at1024:order-1 at1024:pr-16 at1024:w-1/2 at1440:pr-24"
            >
                <img
                    src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/example-parts-conversation"
                    class="block mx-auto"
                    height="607"
                    width="585"
                    sizes="585px"
                    loading="lazy"
                    alt="An example conversation between a sales rep and a customer, discussing a particular part"
                />
            </div>
            <div
                class="order-1 max-w-lg at1024:max-w-none at1024:order-2 at1024:w-1/2"
            >
                <h3
                    class="font-semibold leading-none max-w-[250px] mb-4 text-3xl text-white tracking-tight at768:max-w-md at768:text-5xl at1024:max-w-lg at1200:text-[70px]"
                >
                    With SECLOCK, your problems are no problem
                </h3>
                <p
                    class="leading-[1.15] at768:text-xl at1024:text-2xl at1200:leading-tight at1200:text-[35px]"
                >
                    Our technical sales reps have been on the other side. They
                    know exactly what it takes to do the work you do, and that’s
                    why they’re perfectly suited to help you solve any issue in
                    the field.
                </p>
            </div>
        </section>

        <section class="px-4 py-8 at1024:px-8 at1440:py-12">
            <ul
                class="flex flex-col gap-4 text-white at768:flex-row at1024:gap-[30px]"
            >
                <li
                    class="bg-gray-800 p-6 rounded-md at768:flex at768:flex-col at768:justify-between at768:w-1/2 at1024:p-12 at1440:p-16"
                >
                    <div>
                        <h3
                            class="font-semibold leading-none mb-4 text-3xl text-white tracking-tight at1024:text-5xl at1200:text-[70px]"
                        >
                            Already a SECLOCK customer?
                        </h3>
                        <p
                            class="leading-[1.15] at768:text-xl at1024:text-2xl at1200:leading-tight at1200:text-[35px]"
                        >
                            Browse our inventory now.
                        </p>
                    </div>
                    <div class="mt-8 text-right">
                        <Link href="/login" class="btn-white-on-red">{{ $t("Login") }}</Link>
                    </div>
                </li>
                <li
                    class="bg-red p-6 rounded-md at768:flex at768:flex-col at768:justify-between at768:w-1/2 at1024:p-12 at1440:p-16"
                >
                    <div>
                        <h3
                            class="font-semibold leading-none mb-4 text-3xl text-white tracking-tight at1024:text-5xl at1200:text-[70px]"
                        >
                            Not a SECLOCK customer?
                        </h3>
                        <p
                            class="leading-[1.15] at768:text-xl at1024:text-2xl at1200:leading-tight at1200:text-[35px]"
                        >
                            Sign up to get access to the industry’s largest
                            in-stock inventory.
                        </p>
                    </div>
                    <div class="mt-8 text-right">
                        <a href="/register" class="btn-blue-on-white">{{ $t("Register today") }}</a>
                    </div>
                </li>
            </ul>
        </section>
    </div>
    <Meta
        title="Door Hardware Parts | Wholesale Door Hardware"
        description="Wholesale Door Hardware Parts and accessories are available at SECLOCK. Call 800.847.5625 for  closer arms, retrofit kits, extension rods, screw packs, strike plates, and more."
    />
</template>

<script setup>
import { onMounted, ref } from "vue";
import * as LottiePlayer from "@lottiefiles/lottie-player";
import { create } from "@lottiefiles/lottie-interactivity";
import { BaseSvg, Meta } from "@/Components";

const partsAnimation = ref(null);

onMounted(() => {
    partsAnimation.value.addEventListener("load", function () {
        create({
            container: "#parts-animation-context",
            player: "#parts-animation",
            mode: "scroll",
            actions: [{
                visibility: [0.25, 1.0],
                type: "play",
            }],
        });
    });
});
</script>
